// extracted by css-extract-rspack-plugin
export default {"dropdown":"Tooltip-module__dropdown___nmz7i","target":"Tooltip-module__target___uZBFj","tooltip":"Tooltip-module__tooltip___lgH6L"};